import { graphql } from 'gatsby';
import { createGatsbyPageComponent } from '@shapeable/ui';
export default createGatsbyPageComponent('Page');

export const QUERY = graphql`
query PageQuery($id: ID!) {
  platform { page(id: $id) {
    
      
    
        id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
    
      
      title 
      pretitle
      subtitle
      titleRich { id text }
      subtitleRich { id text }
      published
      content { id text }
      options { id text }
      intro { id plain text }
      outro { id text }
      themeMode { slug }
      bannerThemeMode { slug }
      orderNumber
      openGraph { title description { plain } image { thumbnails { card { url url2x } bubble { url url2x } } } }
      banners {
        id name slug title description { text } alternateText
        image { 
          id url url2x width height thumbnails { halfBanner { url url2x } mainBanner { url url2x } } 
        }
      }
      layout {
        id name slug component 
      }
      videos {
        id name url
        openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
      }
      imageAssets {
        id image { id url url2x type }
      }
      people {
        id name slug path
        organisation { id name }
        linkedin
        position
        openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
      }
      embeds {
        citations {
          slug url name authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year
        }
        pages {
          id name slug path
          openGraph {
            title description { plain }
            image { thumbnails { bubble { url url2x } card { url url2x } } }
          }
        }
        people {
          id name slug path
          organisation { id name }
          position
          openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
        }
        imageAssets {
          id
          slug
          name 
          image {
            id url url2x type
          }
        }
        posts {
          id name slug path type { name }
          openGraph {
            title description { plain text }
            image { url url2x type }
          }
        }
      }
      parent {
        __typename id name path slug title subtitle pretitle 
        content { text }
        children {
          __typename id name path slug title subtitle pretitle 
          openGraph { description { text } image { thumbnails { card { url url2x } } } }
          intro { text }
          orderNumber
        }
      }
      bannerLinks {
        id name slug url __typename
        type { id name }
        typeLabel
        banner {
          id name slug
          image { id url url2x width height thumbnails { halfBanner { url url2x } mainBanner { url url2x } } }
        }
        page { 
          id name slug path __typename 
          type { id name }
          title
          subtitle
          openGraph { id image { id url url2x } }
        }
        post { 
          id name slug path __typename 
          typeLabel
          title
          subtitle
          openGraph { id image { id url url2x } }
        }
        economy { 
          id name slug path __typename 
          typeLabel
          openGraph { id image { id url url2x } }
        }
        organisation {
          id name slug path __typename 
          typeLabel
          openGraph { id image { id url url2x } }
        }
        person {
          id name slug path __typename 
          typeLabel
          openGraph { id image { id url url2x } }
        }
        product {
          id name slug path __typename 
          typeLabel
          openGraph { id image { id url url2x } }
        }
        team {
          id name slug path __typename 
          typeLabel
          openGraph { id image { id url url2x } }
        }
        bannerTitle
        bannerSubtitle
        openGraph { id image { id url thumbnails { card { url url2x } } } }
      }
      cardLinks {
        id name path slug url __typename
        type { id name }
        typeLabel
        bannerTitle
        bannerSubtitle
        openGraph { id image { id url url2x thumbnails { card { url url2x } } } }
        page { 
          id name slug path __typename 
          typeLabel
          type { id name }
          title
          subtitle
          openGraph { id image { id url url2x } }
        }
        event { 
          id name slug path __typename 
          typeLabel
          title
          subtitle
          openGraph { id image { id url url2x } }
        }
        post { 
          id name slug path __typename 
          typeLabel
          title
          subtitle
          openGraph { id image { id url url2x } }
        }
        economy { 
          id name slug path __typename 
          typeLabel
          openGraph { id image { id url url2x } }
        }
        organisation {
          id name slug path __typename 
          typeLabel
          openGraph { id image { id url url2x } }
        }
        person {
          id name slug path __typename 
          typeLabel
          openGraph { id image { id url url2x } }
        }
        product {
          id name slug path __typename 
          typeLabel
          openGraph { id image { id url url2x } }
        }
        team {
          id name slug path __typename 
          typeLabel
          openGraph { id image { id url url2x } }
        }
      }
      children {
        __typename id name path slug title subtitle pretitle 
        openGraph { description { text } image { thumbnails { card { url url2x } } } }
        intro { text }
        orderNumber
      }
    
      slices {
        id name slug 
        title
        titleRich { id text }
        subtitle
        subtitleRich { id text }
        disabled
        created updated
        outro { text }
        intro { text }
        themeMode { slug }
        images {
          id name slug alternateText description { text }
          image { 
            id url url2x type width height thumbnails { mainBanner { url url2x } } 
          }
        }
        pages {
          id name path disabled
        }
        people {
          __typename
          id name slug 
          openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
          photo { url url2x type }
          position
          bio { text html(links: { target: "_blank" }) }
          linkedin
          organisation { id name }
        }
        links { 
          id name slug label isDownload url page { id name path } type { id name } file { file { url } } 
        }
        options { text }
        files {
          id
          name
          slug
          file {
            id
            url
          }
          openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
        }
        videos { 
          url 
          openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
        }
        color { value }
        backgroundColor { value }
        backgroundImages {
          image {
            url url2x
          }
        }
        blocks {
          id name slug __typename
          pretitle
          title 
          titleRich { id text }
          subtitle
          links { id name slug label isDownload url page { path } type { id name } file { file { url } } }
          page { id path name }
          links { id url name }
          pages { id name }
          content { id text }
          options { id text }
          color { value }
          backgroundColor { value }
          icon { openGraph { image { id type width height url url2x } } }
          image { 
            id 
            image {
              url url2x type width height thumbnails { card { url url2x } halfBanner { url url2x } mainBanner { url url2x } } 
            }
          }
        }
        content { id text }
        image { id }
        layout { id name slug component }
        organisations {
          id
          name
          url
          organisationStatus { id name }
          logoInverted { type url url2x thumbnails { card { url url2x } } }
          logo { type url url2x thumbnails { card { url url2x } } }
        }
      }
    
    followersCount
    comments {
      embeds {
        imageAssets {
          id
          slug
          image {
            id url url2x width height 
          }
        }
      }
    }
  } }
}
`;
